import { createAsyncThunk } from '@reduxjs/toolkit';

import { HttpError } from '../../api/client';
import { API_ERROR_CODES, type EventDto, type EventUpdateRequest } from '../../api/types';
import { guestAccessErrorMessage } from '../../domain/guestAccess/errors';
import { entitiesActions } from '../slices/entitiesSlice';
import { uiActions } from '../slices/uiSlice';
import type { RootState } from '../store';

import { eventsService } from './_deps';

export const updateEvent = createAsyncThunk<
  EventDto,
  { eventId: string; payload: EventUpdateRequest },
  { state: RootState }
>('events/update', async ({ eventId, payload }, thunkApi) => {
  const { dispatch, getState } = thunkApi;

  try {
    const event = await eventsService.updateEvent({ eventId, payload });
    dispatch(entitiesActions.upsertEvents([event]));
    return event;
  } catch (error) {
    if (error instanceof HttpError && error.payload?.error === API_ERROR_CODES.TIME_CONFLICT) {
      dispatch(
        uiActions.setNotification({
          type: 'error',
          message: 'На это время уже запланировано другое мероприятие',
        }),
      );
    } else if (error instanceof HttpError && error.code?.startsWith('GUEST_ACCESS_')) {
      dispatch(
        uiActions.setNotification({
          type: 'error',
          message: guestAccessErrorMessage(error, 'Не удалось сохранить мероприятие'),
        }),
      );
    }
    throw error;
  }
});
